import { Component, h, Event, EventEmitter, Prop, State, Element, Method } from '@stencil/core';
import ImgPreviewer from "../../utils/img-previewer/index"
import { getLocaleComponentStrings, variableString } from "../../utils/locale";

@Component({
  tag: 'jackery-upload',
  styleUrl: 'jackery-upload.css',
  shadow: true,
})
export class JackeryUpload {
  strings: any;
  @Element() element: HTMLElement;
  /**
  * Prop accept 接受上传的文件类型
  */
  @Prop() accept: string = "*";
  /**
  * Prop limit 上传文件最大数量
  */
  @Prop() limit: number = 5;
  @Prop() sizeLimit: number = 20;
  @Event() fileUploaded: EventEmitter<File[]>;
  @State() selectedFile: FileList;
  @State() errorTips: string = ''; // 错误信息提示
  @State() uploadProgress: number = 0;
  @State() previewImage: string[] = [];
  @Method()
  public async handleReset() { // 重置
    this.previewImage = []
    this.uploadProgress = 0
    this.selectedFile = null
    this.errorTips = ''
    this.element.shadowRoot.querySelector('input').value = null
  }

  handleFileChange(event: Event) {
    this.errorTips = ''
    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;
    const total_size = this.calcSize(files)
    if(files.length > this.limit) {
      this.errorTips = variableString(this.strings.image_max_size, (this.limit || 5).toString())
      setTimeout(() => { this.handleReset() }, 8000);
      return console.warn(variableString(this.strings.image_max_size, (this.limit || 5).toString()))
    }

    if(total_size > this.sizeLimit) {
      console.log(total_size)
      this.errorTips = variableString(this.strings.image_max_mb, (this.sizeLimit || 5).toString())
      setTimeout(() => { this.handleReset() }, 8000);
      return console.warn(variableString(this.strings.image_max_mb, (this.sizeLimit || 5).toString()))
    }
    
    if (files && files.length > 0) {
      this.previewImage = []
      const selectedFile = files;
      this.fileUploaded.emit(selectedFile as any);
      this.selectedFile = selectedFile;

      Array.from(this.selectedFile).forEach((file: File, index) => {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const result = e.target?.result as string;
          this.previewImage = [...this.previewImage, result]
        };
        reader.readAsDataURL(file);

        if(index === this.selectedFile.length - 1) {
          setTimeout(() => {
            new ImgPreviewer('#img-pre__wrapper', {
              fillRatio: 0.7,
              imageZoom: {
                step: 1
              },
              i18n: {
                RESET: this.strings.reset,
                ROTATE_LEFT: this.strings.rotate_left,
                ROTATE_RIGHT: this.strings.rotate_right,
                CLOSE: this.strings.close,
                NEXT: this.strings.next,
                PREV: this.strings.prev
              },
              style: {
                modalOpacity: 0.8
              },
              bubblingLevel: 1,
              root: this.element.shadowRoot
            } as any)
          }, 200);
        }
      })
    }
  }

  calcSize(files: FileList): number { // 计算文件总大小
    let total_size = 0 // 文件总大小
    Array.from(files).forEach(file => {
      total_size += file.size / 1024 / 1024
    })
    return total_size
  }

  async componentWillLoad(): Promise<void> {
    this.strings = await getLocaleComponentStrings(this.element);
  }

  render() {
    return (
      <div>
        <div class="write_review_file">
          <input 
            type="file" 
            accept={this.accept}
            multiple
            onChange={(event) => this.handleFileChange(event)} 
          />
          
          <div class="areviews_file_label">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="17" 
              height="17" 
              viewBox="0 0 20 17"
            >
              <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z">
              </path>
            </svg>
            <span>
              {this.previewImage.length > 0 
                ? variableString(this.strings.image_slected_text, (this.previewImage.length || 0).toString())
                : this.strings.form_image_label
              }
              </span>
          </div>

        </div>
          {this.selectedFile && (
            <div>
              <div id="img-pre__wrapper">
                {this.previewImage.map((file) =>
                  <div class="pre__item_wrapper">
                    <img src={file} alt="Preview" />
                  </div>
                )}
                {/* <img src={this.previewImage} alt="Preview" /> */}
              </div>
              {/* <div>文件名: {this.selectedFile.name}</div>
              <div>大小: {this.selectedFile.size} bytes</div> */}
            </div>
          )}

          {this.errorTips && <div class="upload__error__tips">{this.errorTips}</div>}
      </div>
    );
  }
}
